import { createClient } from "@supabase/supabase-js"

function readSupabaseUrl(): string {
  let raw: string | undefined
  try {
    // IMPORTANT: keep this as a direct `import.meta.env.VITE_*` access so Vite can inject it.
    raw = import.meta.env.VITE_SUPABASE_URL as string | undefined
  } catch {
    // ignore (Node / non-Vite runtime)
  }
  if (!raw && typeof process !== "undefined") raw = process.env.VITE_SUPABASE_URL
  if (!raw) throw new Error("Missing VITE_SUPABASE_URL in .env.local")

  // Accept either full URL or the common `<project>.supabase.co` form.
  if (raw.startsWith("http://") || raw.startsWith("https://")) return raw
  return `https://${raw}`.replace(/\/$/, "")
}

function readSupabaseAnonKey(): string {
  let key: string | undefined
  try {
    // IMPORTANT: keep this as a direct `import.meta.env.VITE_*` access so Vite can inject it.
    key = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined
  } catch {
    // ignore (Node / non-Vite runtime)
  }
  if (!key && typeof process !== "undefined") key = process.env.VITE_SUPABASE_ANON_KEY
  if (!key) throw new Error("Missing VITE_SUPABASE_ANON_KEY in .env.local")

  // Safety check: service-role keys are secrets and must never be used in a browser app.
  if (key.startsWith("sb_secret_")) {
    throw new Error(
      "VITE_SUPABASE_ANON_KEY looks like a secret key (sb_secret_*). Replace it with the public anon key from Supabase."
    )
  }

  return key
}

/** For Edge `fetch` calls from the browser (avoids `invoke` issues; same host + anon + apikey). */
export function getPublicSupabaseConfig(): { supabaseUrl: string; anonKey: string } {
  return { supabaseUrl: readSupabaseUrl(), anonKey: readSupabaseAnonKey() }
}

/** Used by `signUp` / `auth.resend` confirmation emails. Must be listed under Supabase → Auth → URL Configuration → Redirect URLs. */
export function emailConfirmationRedirectUrl(): string {
  return `${window.location.origin}/login`
}

export const supabase = createClient(readSupabaseUrl(), readSupabaseAnonKey())
